import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetContent = async (
  pageNumber,
  filters,
  setLoading,
  institutionId,
  searchTerm
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.get(`${apiConfig.baseURL}/app-content/${institutionId}`, {
      headers: apiConfig.headers,
      params: {
        page: pageNumber,
        totalPerPage: 10,
        searchKey: searchTerm,
        ...filters,
      },
    });
    return result;
  } catch (error) {
    console.error("Error fetching content:", error);
    return error;
  }
};

export const APICreateContent = async (
  contentData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const formattedData = {
      ...contentData,
      institutionId: institutionId,
    };

    const result = await axios.post(
      `${apiConfig.baseURL}/app-content`,
      formattedData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error creating content:", error);
    return error;
  }
};

export const APIUpdateContent = async (
  contentData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  const formattedData = {
    ...contentData,
    institutionId: institutionId,
  };

  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}/app-content/`,
      formattedData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating app content:", error);
    return error;
  }
};

export const APIDeleteContent = async (
  cmsId,
  setLoading,
  institutionId,
  token,
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  const formattedData = {
    cmsIds: [cmsId],
    institutionId: institutionId,
  };

  try {
    const result = await axios.delete(`${apiConfig.baseURL}/app-content`, {
        headers: {
        ...apiConfig.headers,
        token: token,
        institutionId: institutionId,
      },
      data: formattedData,
    });
    return result;
  } catch (error) {
    console.error("Error deleting service content:", error);
    return error;
  } finally {
    setLoading(false);
  }
};
